import styled, {css} from "styled-components/macro";
import {device} from "../../styles";
import ReactTooltip from "react-tooltip";

export const Root = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-top: 20px;

    ${device.less768} {
        width: 100%;
    }
`;

export const Text = styled.div`
    font-size: 14px;
    line-height: 20px;
    color: var(--color-comment);
    padding-right: 10px;

    ${device.less768} {
        font-size: 10px;
        line-height: 15px;
        color: var(--color-comment);
    }
`;

export const Button = styled.div`
    cursor: pointer;

    svg {
        width: 20px;
        height: 20px;
        
        ${device.less768} {
            width: 15px;
            height: 15px;
        }
    }
`;


export const TooltipRoot = styled(ReactTooltip)`
    opacity: 1 !important;
    
`;


export const TooltipImage = styled.div<{$src: string}>`
    width: 250px;
    height: 250px;
    overflow: hidden;
    border: 2px solid var(--color-border);
    background: var(--color-border) center center no-repeat;
    background-size: cover;
    
    ${(props) => props.$src && css`
        background-image: url(${props.$src});
    `}

    ${device.less768} {
        width: 250px;
        height: 250px;
    }
`;
